@if (!isEditing) {
  <div>
    <div class="col-12">
      <div>
        <span>{{ primaryReasonText }}</span>
      </div>
    </div>
    @if (secondaryReasonCheck) {
      <div class="col-12">
        <div>
          <label>Additional reasons for the exclusion were:</label>
        </div>
        <div>
          <ul>
            @for (reason of secondaryReason; track reason) {
              <li>{{ reason }}</li>
            }
          </ul>
        </div>
      </div>
    }
  </div>
}
@if (isEditing || isCreateExclusion) {
  <div>
    <form [formGroup]="userFields">
      <div class="grid">
        <div class="col-6">
          <label for="primaryReason"
            >Primary Reason :<span class="error-label">*</span></label
          >
          <div class="width-twentyone">
            <p-select
              [options]="allReasonsList"
              id="primaryReason"
              formControlName="primaryReason"
              optionLabel="description"
              optionValue="description"
              placeholder="Please select"
              (onChange)="changePrimaryReasonOptions($event)"
              #dropdownPrimaryReason
            ></p-select>
            @if (
              (f.primaryReason.invalid && f.primaryReason.touched) ||
              f.primaryReason.dirty
            ) {
              <div class="float-left">
                @if (f.primaryReason.errors?.required) {
                  <small class="error-label">Primary reason is required</small>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-12">
          <label for="additionalReason"
            >Additional Reason(s) :
            {{ countSelectedAddnReasons }} selected</label
          >
          <div class="width-twentyone">
            <p-listbox
              [metaKeySelection]="false"
              [options]="filteredReasonsList"
              placeholder="Please select"
              [filter]="false"
              id="additionalReason"
              formControlName="additionalReason"
              [checkbox]="true"
              [multiple]="true"
              [listStyle]="{ 'max-height': '250px' }"
              optionLabel="description"
              optionValue="description"
              (onChange)="countAdditionalReasons($event)"
              #additionalReasonsListBox
            >
            </p-listbox>
          </div>
        </div>
      </div>
      @if (isEditing) {
        <div class="align-right grid">
          <div class="col">
            <button
              title="Cancel"
              label="Cancel"
              pButton
              class="button-custom margin-right"
              (click)="cancelReasons()"
            ></button>
            <button
              title="Save"
              label="Save"
              pButton
              class="button-custom margin-right"
              (click)="SaveReasons()"
            ></button>
          </div>
        </div>
      }
    </form>
  </div>
}
@if (
  (!isStudentOffRoll || isOffRollEditingEnabled) &&
  !isEditing &&
  !isCreateExclusion
) {
  <div class="grid">
    <div class="col">
      <button
        pButton
        type="button"
        class="float-right"
        (click)="editReasons()"
        title="Edit Reasons"
        label="Edit Reasons"
        #editReasonsButton
      ></button>
    </div>
  </div>
}
